import Home from "./Components/index";
function App() {
  return (
    <Home/>
  );
}

export default App;
